module.exports = __webpack_public_path__ + "media/src/img/pagination-arrow-26af43a46f5e5a2a981642539ed6efec.svg";